import React, { PureComponent } from 'react'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import FormControl from '@material-ui/core/FormControl'
import LockOpen from '@material-ui/icons/LockOpen'

import ModalDialog from '../common/ModalDialog'
import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'

class WeedmapDiscontinueItemsModal extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      password: '',
    }
  }

  setPassword = (event) => {
    this.setState({
      password: event.target.value,
    })
  }

  onConfirm = () => {
    const { password = '' } = this.state

    if (!password || !password.trim()) {
      return this.props.showError('Please enter your password')
    }

    this.props.onConfirm(this.state.password)
  }

  resetPassword = () => {
    this.setState({
      password: '',
    })
  }

  render() {
    const {
      forwardedRef,
      title = 'CONFIRM "DISCONTINUE"',
      confirmText = 'Yes, continue',
      cancelText = 'No',
    } = this.props
    const { password = '' } = this.state

    return (
      <ModalDialog
        title={title}
        ref={forwardedRef}
        onConfirm={this.onConfirm}
        confirmText={confirmText}
        cancelText={cancelText}
        onClose={this.resetPassword}
      >
        <p>
          Warning: This will wipe your Weedmaps menu, only initiate this action under the direction
          of BLAZE support
        </p>
        <FormControl fullWidth>
          <InputLabel htmlFor="input-with-icon-adornment">Please enter your password</InputLabel>
          <Input
            onChange={this.setPassword}
            value={password}
            type="password"
            id="input-with-icon-adornment"
            startAdornment={
              <InputAdornment position="start">
                <LockOpen />
              </InputAdornment>
            }
          />
        </FormControl>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(WeedmapDiscontinueItemsModal)



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedmapDiscontinueItemsModal.js